import { type MantineColor } from '@mantine/core'
import { type SugarProviderPhotoStatus } from '@app/types'

export interface PhotoStatusDisplay {
  label: string
  color: MantineColor
}

// API status → UI presentation. The ticket UI copy ("Pending Review", "Rejected")
// intentionally differs from the API enum strings; this is the only place that
// translation lives.
export const PHOTO_STATUS_DISPLAY: Record<SugarProviderPhotoStatus, PhotoStatusDisplay> = {
  'Under Review': { label: 'Pending Review', color: 'yellow' },
  'Active': { label: 'Active', color: 'green' },
  'invalid': { label: 'Rejected', color: 'red' }
}
